import { React } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { Button, Form, Input, message } from 'antd'
import { useContext } from 'react'
import { MyContext } from '../context'

const onFinishFailed = errorInfo => {
  console.log('Failed:', errorInfo)
}

const App = () => {
  const { isLogin, dispatch } = useContext(MyContext)
  // redirectUrl要用到searchParam，所以只能App组件中
  const onFinish = values => {
    const { username, password } = values
    if (username === 'admin' && password === 'xywzBw_78@FwZTEA') {
      localStorage.setItem('logined', true)
      dispatch({
        type: 'login',
        isLogin: true
      })
      message.success('登录成功')
      const redirectUrl = searchParams.get('redirect')
      // console.log('redirectUrl', redirectUrl)
      if (redirectUrl) {
        navigate(redirectUrl)
      }
    } else {
      message.error('用户名或密码错误')
    }
  }
  const logout = () => {
    localStorage.removeItem('logined')
    dispatch({
      type: 'logout',
      isLogin: false
    })
    message.success('退出成功')
  }
  // 跳转回登录前的请求地址
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  return isLogin ? (
    <>
      <b>欢迎你</b>
      <Button type="link" onClick={logout}>
        退出
      </Button>
    </>
  ) : (
    <Form
      name="basic"
      labelCol={{
        span: 8
      }}
      wrapperCol={{
        span: 8
      }}
      style={{}}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <Form.Item
        label="用户名"
        name="username"
        rules={[
          {
            required: true,
            message: '请输入用户名'
          }
        ]}
      >
        <Input placeholder="请输入用户名" />
      </Form.Item>

      <Form.Item
        label="密码"
        name="password"
        rules={[
          {
            required: true,
            message: '请输入密码'
          }
        ]}
      >
        <Input.Password placeholder="请输入密码" />
      </Form.Item>

      <Form.Item
        wrapperCol={{
          offset: 4,
          span: 16
        }}
      >
        <Button type="primary" htmlType="submit">
          登录
        </Button>
      </Form.Item>
    </Form>
  )
}

export default App
